var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriversLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-landscape 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29 5H11C9.34315 5 8 6.67893 8 8.75V31.25C8 33.3211 9.34315 35 11 35H29C30.6569 35 32 33.3211 32 31.25V8.75C32 6.67893 30.6569 5 29 5Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.861 18.4231L24.7541 14.8691C24.6494 14.4665 24.4618 14.1196 24.2163 13.875C23.9709 13.6303 23.6794 13.4994 23.3809 13.5H16.6211C16.3226 13.4994 16.0311 13.6303 15.7857 13.875C15.5403 14.1196 15.3526 14.4665 15.2479 14.8691L14.141 18.4231",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.5 24.5507V25.8077C14.5 26.1341 14.6297 26.4472 14.8605 26.678H15.6314C15.6314 26.678 15.9918 26.1341 15.9918 25.8077V24.5769",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.5 24.5507V25.8077C24.5 26.1341 24.6297 26.4472 24.8605 26.678H25.6314C25.6314 26.678 25.9918 26.1341 25.9918 25.8077V24.5769",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.9662 21C24.0478 21 24.1261 21.0324 24.1838 21.0901C24.2415 21.1478 24.2739 21.2261 24.2739 21.3077",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.6585 21.3077C23.6585 21.2261 23.6909 21.1478 23.7486 21.0901C23.8063 21.0324 23.8846 21 23.9662 21",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.9662 21.6154C23.8846 21.6154 23.8063 21.583 23.7486 21.5253C23.6909 21.4676 23.6585 21.3893 23.6585 21.3077",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.2739 21.3077C24.2739 21.3893 24.2415 21.4676 24.1838 21.5253C24.1261 21.583 24.0478 21.6154 23.9662 21.6154",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.0338 21C15.9522 21 15.8739 21.0324 15.8162 21.0901C15.7585 21.1478 15.7261 21.2261 15.7261 21.3077",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.3415 21.3077C16.3415 21.2261 16.3091 21.1478 16.2514 21.0901C16.1937 21.0324 16.1154 21 16.0338 21",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.0338 21.6154C16.1154 21.6154 16.1937 21.583 16.2514 21.5253C16.3091 21.4676 16.3415 21.3893 16.3415 21.3077",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M15.7261 21.3077C15.7261 21.3893 15.7585 21.4676 15.8162 21.5253C15.8739 21.583 15.9522 21.6154 16.0338 21.6154",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M13.8333 18.4231H26.1667C26.5203 18.4231 26.8594 18.6024 27.1095 18.9215C27.3595 19.2407 27.5 19.6735 27.5 20.1249V23.3158C27.5 23.5414 27.4298 23.7579 27.3047 23.9174C27.1797 24.077 27.0101 24.1667 26.8333 24.1667H13.1667C12.9899 24.1667 12.8203 24.077 12.6953 23.9174C12.5702 23.7579 12.5 23.5414 12.5 23.3158V20.1249C12.5 19.6735 12.6405 19.2407 12.8905 18.9215C13.1406 18.6024 13.4797 18.4231 13.8333 18.4231Z",
    stroke: "#5F738C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicense);
export default __webpack_public_path__ + "static/media/drivers_license.e2b0455b93d30313bfec652f003dcf18.svg";
export { ForwardRef as ReactComponent };